import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  appEssentialFetch,
} from "../../actions";

const PrivacyPlicyPage = (props) => {

  useEffect(() => {
    props.appEssentialFetch();
  }, [])

  return (
    <main>
      <Helmet>
        <title>Privacy-Policy | company name</title>
        <meta name="description" content="Dashingdish privacy-policy page" />
        <script type="text/javascript">{`(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);`}</script>
      </Helmet>
      <div className="container">
        <a href="https://www.iubenda.com/privacy-policy/516411" class="iubenda-white no-brand iubenda-embed iub-body-embed" title="Privacy Policy">Privacy Policy</a>
      </div>
    </main >
  )
}

const mapStateToProps = () => ({

})

const dispatchActionToProps = dispatch => ({
  appEssentialFetch: bindActionCreators(appEssentialFetch, dispatch),
})

export default connect(mapStateToProps, dispatchActionToProps)(PrivacyPlicyPage);